import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import CategorySummaryComponent from "./CategorySummaryComponent.jsx";

export default function DraggableCategory({
	                                          category,
	                                          index,
	                                          categoryToNewTransaction,
	                                          categoryEditCategories,
	                                          selectedDateKey,
	                                          categoryEditBudgets,
	                                          budgetMayHaveUpdated,
	                                          ...props
                                          }) {


	return (
		<Draggable
			draggableId={`draggableCategory-${category.id}`}
			index={index}
			key={category.id}
		>
			{(provided, snapshot) => (
				<div
					className={`category ${snapshot.isDragging ? 'is_dragging' : ''}`}
					ref={provided.innerRef}
					{...provided.draggableProps}
				>
					<CategorySummaryComponent
						key={`${category.id} ${selectedDateKey}`}
						{...props}
						dragHandleProps={provided.dragHandleProps}
						category={categoryEditCategories.current.get(category)}
						categoryToNewTransaction={categoryToNewTransaction}
						editBudget={categoryEditBudgets.current.get(category)}
						budgetMayHaveUpdated={budgetMayHaveUpdated}
					/>
				</div>
			)}
		</Draggable>
	);
}